export const OBJECTIVES = {
  PACIENTES: { min: 10, max: 50, points: 10, bonus: 5 }, //100
  PRESTACIONES: { min: 10, max: 20, points: 10, bonus: 10 }, //100
  AFILIACIONES: { min: 10, max: 15, points: 20, bonus: 10 }, //200
  CITAS:{ min: 10, max: 15, points: 20, bonus: 20 }, //200
  TRANSACCIONES: { min: 10, max: 20, points: 10, bonus: 5 },//200
}
 
export const DESCUENTO_MAXIMO = 30; // Porcentaje máximo de descuento en la renovación del plan
 export const POLITICA_PUNTOS = `
 1. Los puntos obtenidos en el plan free no son acumulables y se reinician cada mes.
 2. Los puntos solo pueden ser utilizados para obtener descuentos en la renovación del plan.  
  3. El descuento máximo que se puede obtener es del ${DESCUENTO_MAXIMO}%.
  `;
 export const VARIABLES_POLITICA = {
  PUNTAJE_MINIMO: 500,
  PUNTAJE_MAXIMO: 1500,
  DESCUENTO_POR_PUNTAJE_MINIMO: 10,
  DESCUENTO_POR_PUNTAJE_COMPLETO: 30,
  };

